<ng-container *transloco="let t">
    <div
        class="route-loader-bar"
        [class.route-loader-bar--visible]="visible"
        role="status"
        [attr.aria-label]="t('Loading')"
        aria-live="polite"
    >
        <mat-progress-bar mode="indeterminate" class="route-loader-progress"></mat-progress-bar>
    </div>
</ng-container>
